import { useSelector } from 'react-redux';
import { FormSelectField, FormSelectFieldProps } from '@mews/framework';
import { DropdownItem } from '@optimus-web/core';
import { GeneralEnterprise } from '@mews-commander/data-access';
import { getCurrentEnterpriseRelatedTargetEnterprises } from '@mews-commander/legacy-entities/src/selectors/enterprises';

type EnterprisesSelectFieldProps = Omit<FormSelectFieldProps, 'children'>;

const renderEnterprises = (enterprises: Array<GeneralEnterprise>) =>
    enterprises.map(({ id, name }) => <DropdownItem key={id} value={id} label={name} />);

export const EnterprisesSelectField = (props: EnterprisesSelectFieldProps) => {
    const enterprises = useSelector(getCurrentEnterpriseRelatedTargetEnterprises);

    return <FormSelectField {...props}>{renderEnterprises(enterprises)}</FormSelectField>;
};
